import moment from 'moment';
import React, { ReactNode, useEffect, useState } from 'react';
import styles from './index.module.scss';

interface Props {
  title?: string | ReactNode;
  style?: object;
  className?: string;
}

const Timer = ({ title, style, className }: Props) => {
  const [current, setCurrent] = useState(Date.now());
  useEffect(() => {
    const timer: NodeJS.Timeout = setInterval(() => {
      setCurrent(Date.now());
    });
    return () => {
      clearInterval(timer);
    };
  }, []);
  return (
    <div className={`${styles.timeTit} ${className}`} style={style}>
      <span>{title}</span>
      <span>{moment(current).format('YYYY/MM/DD HH:mm:ss')}</span>
    </div>
  );
};
export default Timer;
